{
  "version": 1,
  "asset_id": "d7c7075d-358e-4069-a522-5c2df124612d",
  "project_id": "8adc0465-0e97-4f56-a239-7d822722b630",
  "url": "/__l5e/assets-v1/d7c7075d-358e-4069-a522-5c2df124612d/hero-girl-768.webp",
  "r2_key": "a/v1/8adc0465-0e97-4f56-a239-7d822722b630/d7c7075d-358e-4069-a522-5c2df124612d/hero-girl-768.webp",
  "original_filename": "hero-girl-768.webp",
  "size": 32958,
  "content_type": "image/webp",
  "created_at": "2026-10-01T08:54:47Z"
}
